import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { purchaseOrderService } from '../../services/purchaseOrderService';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';
import PurchaseOrderPrintDocument from '../../components/PurchaseOrders/PurchaseOrderPrintDocument';
import {
  PURCHASE_ORDER_PRINT_PAGE_STYLES,
  PURCHASE_ORDER_PRINT_STYLES,
} from '../../components/PurchaseOrders/purchaseOrderPrintStyles';
import { downloadPurchaseOrderPdf } from '../../utils/generatePurchaseOrderPdf';

const PrintPurchaseOrder = () => {
  const { id } = useParams();
  const { productConversionsEnabled } = useModuleSettings();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pdfLoading, setPdfLoading] = useState(false);

  useEffect(() => {
    loadOrder();
  }, [id]);

  const loadOrder = async () => {
    try {
      const response = await purchaseOrderService.getPurchaseOrder(id);
      if (response.success) {
        setOrder(response.data);
      }
    } catch (error) {
      console.error('Error al cargar orden:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPdf = async () => {
    if (!order || pdfLoading) return;
    setPdfLoading(true);
    try {
      await downloadPurchaseOrderPdf(order, { productConversionsEnabled });
    } catch (error) {
      console.error('Error al generar PDF:', error);
      alert(error?.message || 'No se pudo generar el PDF');
    } finally {
      setPdfLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando orden de compra...</p>
        </div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-red-600 text-lg">Orden no encontrada</p>
        </div>
      </div>
    );
  }

  return (
    <div className="po-print-root">
      <style>{`${PURCHASE_ORDER_PRINT_PAGE_STYLES}${PURCHASE_ORDER_PRINT_STYLES}`}</style>

      <div className="print-actions no-print">
        <button
          onClick={handleDownloadPdf}
          disabled={pdfLoading}
          className="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium shadow-md transition-colors disabled:opacity-60"
        >
          {pdfLoading ? 'Generando PDF…' : 'PDF'}
        </button>
        <button
          onClick={() => window.close()}
          className="px-5 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 font-medium shadow-md transition-colors"
        >
          Cerrar
        </button>
      </div>

      <PurchaseOrderPrintDocument
        order={order}
        productConversionsEnabled={productConversionsEnabled}
      />
    </div>
  );
};

export default PrintPurchaseOrder;
